<template>
  <div class="frequency-settings">
    <div class="frequency-header">
      <h3 class="form-label section-title">{{ $t('messages.frequency') }}</h3>
    </div>

    <div class="frequency-rules">
      <div class="frequency-rule">
        <div class="frequency-inputs">
          <input type="number" v-model.number="frequency" :disabled="!frequency_active" class="frequency-count-input"
            min="1" placeholder="0" />
          <span class="frequency-text">{{ $t('messages.views_in') }}</span>
          <input type="number" v-model.number="period_value" :disabled="!frequency_active"
            class="frequency-period-value-input" min="1" placeholder="1" v-if="period_type !== 'lifetime'" />
          <select v-model="period_type" :disabled="!frequency_active" class="frequency-period-select">
            <option value="day">{{ $t('messages.day') }}</option>
            <option value="week">{{ $t('messages.week') }}</option>
            <option value="month">{{ $t('messages.month') }}</option>
            <option value="lifetime">{{ $t('messages.lifetime') }}</option>
          </select>
        </div>

        <div style="margin-top:8px;">
          <label class="frequency-checkbox-container">
            <input type="checkbox" v-model="frequency_active" />
            <span style="margin-left:8px;">{{ $t('messages.frequency_active') || $t('messages.frequency') }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FrequencySettings",
  props: {
    value: {
      type: Object,
      default: () => ({
        frequency: null,
        period_type: 'day',
        period_value: 1,
        frequency_is_active: true
      })
    }
  },
  data() {
    return {
      frequency: this.value.frequency ?? null,
      period_type: this.value.period_type ?? 'day',
      period_value: this.value.period_value ?? 1,
      frequency_active: !!this.value.frequency_is_active,

    };
  },
  watch: {
    value: {
      handler(v) {
        this.frequency = v.frequency ?? this.frequency;
        this.period_type = v.period_type ?? this.period_type;
        this.period_value = v.period_value ?? this.period_value;
        this.frequency_active = !!v.frequency_is_active;
      },
      deep: true,
      immediate: true
    },
    frequency() { this.emitUpdate(); },
    period_type() { this.emitUpdate(); },
    period_value() { this.emitUpdate(); },
    frequency_active() { this.emitUpdate(); },

  },
  methods: {
    emitUpdate() {
      this.$emit('update', {
        frequency: this.frequency,
        period_type: this.period_type,
        period_value: this.period_value,
        frequency_is_active: this.frequency_active,

      });
    },
    getCurrentFrequency() {
      return {
        frequency: this.frequency,
        period_type: this.period_type,
        period_value: this.period_value,
        frequency_is_active: this.frequency_active,

      };
    }
  }
};
</script>

<style scoped>
.frequency-header {
  margin-bottom: 16px;

  h3 {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }
}

.frequency-rules {
  margin-bottom: 16px;
}

.frequency-rule {
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

.frequency-checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.frequency-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.frequency-count-input {
  width: 60px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  padding: 0 8px;
  color: #333333;
  font-size: 14px;
  text-align: center;

  &:focus {
    outline: none;
    border-color: #e91e63;
    box-shadow: 0 0 0 2px rgba(233, 30, 99, 0.1);
  }
}

.frequency-text {
  color: #e0e0e0;
  font-size: 14px;
  white-space: nowrap;
}

.frequency-period-value-input {
  width: 60px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  padding: 0 8px;
  color: #333333;
  font-size: 14px;
  text-align: center;

  &:focus {
    outline: none;
    border-color: #e91e63;
    box-shadow: 0 0 0 2px rgba(233, 30, 99, 0.1);
  }
}

.frequency-period-select {
  height: 32px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  padding: 0 8px;
  color: #333333;
  font-size: 14px;
  min-width: 80px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #e91e63;
    box-shadow: 0 0 0 2px rgba(233, 30, 99, 0.1);
  }
}

.frequency-remove-btn {
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  color: #e0e0e0;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
}

/* Override global reset that hides checkboxes/radios */
.frequency-settings input[type="checkbox"],
.frequency-settings input[type="radio"] {
  display: inline-block !important;
  width: 16px;
  height: 16px;
  margin: 0;
  vertical-align: middle;
  -webkit-appearance: checkbox;
  appearance: checkbox;
  cursor: pointer;
}

.frequency-settings input[type="checkbox"]:disabled,
.frequency-settings input[type="radio"]:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
